














































































































import { MetadataType } from '@adobe/edex/ui/shared/frontend/utils/types';
import { uniqueId, keyBy, compact } from 'lodash-es';
import { mapState, mapActions } from 'vuex';

export default {
  props: ['items', 'editMode', 'profile'],
  data() {
    return {
      selected: new Set(),
      MODAL_NAME: uniqueId('certifications-picker'),
      hoverID: null,
    };
  },
  methods: {
    ...mapActions('metadata', ['fetchByType']),
    resetSelected() {
      this.selected = new Set(this.items.map(({ id }) => id));
    },
    isChecked(id) {
      return this.selected.has(id);
    },
    onChange() {
      this.$emit('onChange', Array.from(this.selected));
      this.$modal.hide(this.MODAL_NAME);
    },
    onSelect(e, id) {
      if (e.currentTarget.checked) {
        this.selected.add(id);
      } else {
        this.selected.delete(id);
      }
      this.selected = new Set(this.selected);
    },
    showModal() {
      this.$modal.show(this.MODAL_NAME);
    },
    onCancel() {
      this.resetSelected();
      this.$modal.hide(this.MODAL_NAME);
    },
    onRemoveItem(id) {
      this.selected.delete(id);
      this.selected = new Set(this.selected);
      this.$emit('onChange', Array.from(this.selected));
    },
  },
  computed: {
    ...mapState('metadata', ['certifications']),
    certificationsCols() {
      const earnedCertBadges =
        this.profile?.badgesByCategory?.['i18n.badge.certifications'] || [];
      const certs = this.certifications.filter(
        c =>
          c.type === 'Self-Awarded' ||
          earnedCertBadges.some(b => b.id === c.badge.id)
      );
      const mid = Math.ceil(certs.length / 2);
      return [certs.slice(0, mid), certs.slice(mid)];
    },
    metadataByID() {
      return keyBy(this.certifications, 'id');
    },
    displayItems() {
      return this.editMode && this.metadataByID
        ? compact([...this.selected].map(id => this.metadataByID[id]))
        : this.items;
    },
  },
  watch: {
    editMode: {
      handler(val) {
        this.resetSelected();
        if (val) {
          this.fetchByType(MetadataType.certifications);
        }
      },
      immediate: true,
    },
  },
};
